import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "right" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InputRecorder = _resolveComponent("InputRecorder")
  const _component_SendButton = _resolveComponent("SendButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InputRecorder, {
      class: "recorder",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onTranscribed: _cache[1] || (_cache[1] = $event => (_ctx.$emit('transcribed', $event)))
    }),
    _createVNode(_component_SendButton, {
      class: "send",
      generating: $props.generating,
      "can-push": $props.canPush,
      onPush: _cache[2] || (_cache[2] = $event => (_ctx.$emit('push', $event))),
      onStop: _cache[3] || (_cache[3] = $event => (_ctx.$emit('stop')))
    }, null, 8 /* PROPS */, ["generating", "can-push"])
  ]))
}